import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import * as classes from './classes.module.scss';
import { rulersForDpi } from '../../config/dpi';

export default class Ruler extends PureComponent {
  static propTypes = {
    pos: PropTypes.number.isRequired,
    center: PropTypes.number.isRequired,
    dpi: PropTypes.number.isRequired,
    maxLastTick: PropTypes.number.isRequired
  };

  renderTicks() {
    const {
      pos, center, dpi, maxLastTick
    } = this.props;
    const {
      step, labelStep, labelStepCm, stepCm
    } = rulersForDpi(dpi);
    const firstTick = Math.max(Math.ceil(pos / step) * step, 0);
    const lastTick = Math.min(pos + (center - pos) * 2, maxLastTick);
    let tick = firstTick;
    let tickCm = Math.round(firstTick / 2.54);
    const res = [];
    while (tick < lastTick) {
      let label = null;
      if (window.currentLocale.unit === 'cm') {
        if (tickCm % labelStepCm === 0) {
          label = tickCm;
        }
      } else if (tick % labelStep === 0) {
        label = tick;
      }
      let style;
      const className = classnames(
        classes.tick,
        { [classes.labeledTick]: label !== null }
      );
      if (window.currentLocale.unit === 'cm') {
        style = { left: ((tickCm / 2.54) - pos) * dpi };
      } else {
        style = { left: (tick - pos) * dpi };
      }

      res.push(
        <div className={ className } style={ style } key={ tick }>
          { label }
        </div>
      );
      tick += step;
      tickCm += stepCm;
    }
    return res;
  }

  render() {
    return (
      <div className={ classes.ruler }>
        { this.renderTicks() }
      </div>
    );
  }
}
